"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_2 = require("react");
/** Shows a popover when help icon is clicked. Needs bootstrap */
const PopoverHelpComponent = (props) => {
    const spanRef = (0, react_2.useRef)(null);
    const [Popover, setPopover] = (0, react_2.useState)(null);
    // Load popover module (bootstrap which interferes with Node.js)
    (0, react_2.useEffect)(() => {
        Promise.resolve().then(() => __importStar(require("bootstrap/js/dist/popover"))).then(PopoverModule => {
            setPopover(() => PopoverModule.default);
        });
    }, []);
    (0, react_2.useEffect)(() => {
        const el = spanRef.current;
        let popoverInstance = null;
        if (el && Popover) {
            // Create div with content
            const contentDiv = document.createElement("div");
            react_dom_1.default.render(props.children, contentDiv);
            popoverInstance = new Popover(el, {
                content: contentDiv,
                trigger: props.trigger || "hover",
                placement: props.placement || "top",
                html: true
            });
        }
        return () => {
            if (popoverInstance) {
                popoverInstance.dispose();
            }
        };
    }, [Popover, props.children, props.trigger, props.placement]);
    return (react_1.default.createElement("a", { ref: spanRef, tabIndex: 0 }, props.content ?
        props.content :
        react_1.default.createElement("span", { className: "text-muted", style: { cursor: "pointer" } },
            react_1.default.createElement("i", { className: "fas fa-info-circle" }))));
};
exports.default = PopoverHelpComponent;
